/**
 * Create DI instance
 * @module
 */
var _ = require('optimizely-client-fn');

/**
 * @constructor
 */
function DI() {
  this.__registry = {} as any;

  if (__TEST__) {
    this.__mockedModules = {} as any;
  }
}

/**
 * @param {string|Object} id
 * @param {*} module
 */
DI.prototype.register = function(id:string|any, module:any) {
  if (arguments.length === 1) {
    var self = this;
    _.each(id, function(m, i) {
      self.register(i, m);
    });
    return;
  }

  if (this.__registry[id]) {
    throw new Error('Module already registered for: ' + id);
  }
  this.__registry[id] = module;
};

/**
 * Gets a dependency
 * @param {string} id
 * @return {any}
 */
DI.prototype.get = function(id:string): any {
  if (__TEST__ && this.__mockedModules[id]) {
    var existingModule = this.__registry[id] || {};
    var mockedMethods = this.__mockedModules[id];

    if (_.isFunction(mockedMethods)) {
      return mockedMethods;
    }
    return _.extend({}, existingModule, mockedMethods);
  }
  return this.__registry[id];
};

/**
 * Dumps an array of all registered module keys
 * @returns {string[]}
 */
DI.prototype.getModuleKeys = function(): string[] {
  var registry = this.__registry;
  if (__TEST__) {
    registry = _.extend({}, registry, this.__mockedModules);
  }
  return _.keys(registry);
};

/**
 * Evaluates a dependency getter of the form:
 * ['dep1', 'dep2', 'dep3', function(dep1, dep2, dep3) {
 *   //...
 * }]
 * @param {Array.<string|Function>} getter
 * @return {any}
 */
DI.prototype.evaluate = function(getter:(string|Function)[]): any {
  var len = getter.length;
  var argIds = getter.slice(0, len - 1);
  var evaluateFn = getter[len - 1];

  if (typeof evaluateFn !== 'function') {
    throw new Error('Evaluate must take a function as last element in array');
  }

  var args = _.map(argIds, _.bind(this.get, this));
  return evaluateFn.apply(null, args);
};

if (__TEST__) {
  DI.prototype.mock = function(id, module) {
    this.__mockedModules[id] = module;
  };

  DI.prototype.unmock = function(id, module) {
    this.__mockedModules[id] = undefined;
  };
}

/**
 * Resets the state of all registered dependencies
 */
DI.prototype.reset = function() {
  this.__registry = {} as any;
};

module.exports = {
  /**
   * @return {DI}
   */
  create: function(): any {
    return new DI();
  }
};
